import { Outlet } from "@remix-run/react";

export default function TokensPage() {
   return (
       <Outlet />
   );
}
